export enum TrackedPage {
    accueil_dashboard = 'accueil_dashboard',
    dashboard = 'accueil_espace_client_logue',
    dashboardVisitor = 'accueil_espace_client_non_logue',
    contractsAndOptions = 'vos_contrats_espace_client_logue',
    bills = 'factures_espace_client_logue',
    contractSelector = 'retirer_un_contrat',
    removeContract = 'retirer_ce_contrat',
    account = 'compte_espace_client_logue',
    PARNASSE = 'accueil_parnasse_espace_client_logue',
    NSRU = 'accueil_compte_nsru_sans_contrat_rattache_logue',
    MULTIBAL = 'accueil_compte_secondaire_sans_contrat_rattache_logue',
    SUGGESTED = 'accueil_contrat_suggere',
}
